import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, TextField, FormControlLabel, Checkbox } from '@mui/material';

const EditModal = ({ handleClose, showModal, selectedRowData }) => {
  const [name, setName] = useState('');
  const [procedure, setProcedure] = useState('');
  const [procedureId, setProcedureId] = useState('');
  const [descriptions, setDescriptions] = useState([]);
  const [checkboxes, setCheckboxes] = useState({
    copyPracticeNote: false,
    copyPracticeFiles: false,
    requireNote: false,
    requireDescription: false,
  });

  useEffect(() => {
    if (selectedRowData) {
      const rowData = selectedRowData[0];
      setName(rowData?.name || '');
      setProcedure(rowData?.procedure || '');
      setProcedureId(rowData?.CaseTypeId || '');
      setDescriptions(rowData?.description || []);
      setCheckboxes({
        copyPracticeNote: rowData?.copyPracticeNote || false,
        copyPracticeFiles: rowData?.copyPracticeFiles || false,
        requireNote: rowData?.requireNote || false,
        requireDescription: rowData?.requireDescription || false,
      });
    }
  }, [selectedRowData]);

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    setCheckboxes((prevCheckboxes) => ({
      ...prevCheckboxes,
      [name]: checked,
    }));
  };

  const handleDescriptionChange = (index, field, value) => {
    const updatedDescriptions = [...descriptions];
    updatedDescriptions[index] = { ...updatedDescriptions[index], [field]: value };
    setDescriptions(updatedDescriptions);
  };

  const handleSubmit = async () => {
    try {
      const data = {
        name,
        procedure,
        procedure_id: procedureId,
        copyPracticeNote: checkboxes.copyPracticeNote,
        copyPracticeFiles: checkboxes.copyPracticeFiles,
        requireNote: checkboxes.requireNote,
        requireDescription: checkboxes.requireDescription,
        description: descriptions,
      };

      const response = await axios.put(`https://hms.backend.hiragroupcloud.com/api/update-next/${selectedRowData[0]._id}`, data);
      

      handleClose();
    } catch (error) {
      console.error('Error submitting data:', error);
    }
  };

  return (
    <Dialog open={showModal} onClose={handleClose}>
      <DialogTitle>Edit Next Type</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label="Name"
          type="text"
          fullWidth
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <TextField
          margin="dense"
          label="Procedure"
          type="text"
          fullWidth
          value={procedure}
          onChange={(e) => setProcedure(e.target.value)}
        />
        <TextField
          margin="dense"
          label="Procedure ID"
          type="text"
          fullWidth
          value={procedureId}
          onChange={(e) => setProcedureId(e.target.value)}
        />
        {descriptions.map((desc, index) => (
          <TextField
            key={desc._id}
            margin="dense"
            label={`Description ${index + 1}`}
            type="text"
            fullWidth
            value={desc.description}
            onChange={(e) => handleDescriptionChange(index, 'description', e.target.value)}
          />
        ))}
        <FormControlLabel
          control={
            <Checkbox
              checked={checkboxes.copyPracticeNote}
              onChange={handleCheckboxChange}
              name="copyPracticeNote"
              color="primary"
            />
          }
          label="Copy Practice Note"
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={checkboxes.copyPracticeFiles}
              onChange={handleCheckboxChange}
              name="copyPracticeFiles"
              color="primary"
            />
          }
          label="Copy Practice Files"
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={checkboxes.requireNote}
              onChange={handleCheckboxChange}
              name="requireNote"
              color="primary"
            />
          }
          label="Require Note"
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={checkboxes.requireDescription}
              onChange={handleCheckboxChange}
              name="requireDescription"
              color="primary"
            />
          }
          label="Require Description"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Cancel
        </Button>
        <Button onClick={handleSubmit} color="primary">
          Save Changes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditModal;
